module.exports = __webpack_public_path__ + "img/harmonizacao.eeec91bc.png";